'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class; // Lib


// Actions


// Components


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _currentUserActions = require('../../../../../user/currentUserActions');

var _EmailPreferenceToggle = require('./EmailPreferenceToggle');

var _EmailPreferenceToggle2 = _interopRequireDefault(_EmailPreferenceToggle);

require('./EmailPreferenceToggle.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        toggleEmailPreference: function toggleEmailPreference(userId, emailPreference) {
            return dispatch((0, _currentUserActions.updateCurrentUser)({
                userId: userId,
                changes: {
                    settings: {
                        email: emailPreference
                    }
                }
            }));
        }
    };
};

var EmailPreferenceToggleContainer = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = function (_React$Component) {
    _inherits(EmailPreferenceToggleContainer, _React$Component);

    function EmailPreferenceToggleContainer(props) {
        _classCallCheck(this, EmailPreferenceToggleContainer);

        var _this = _possibleConstructorReturn(this, (EmailPreferenceToggleContainer.__proto__ || Object.getPrototypeOf(EmailPreferenceToggleContainer)).call(this, props));

        _this.updatePreference = _this.updatePreference.bind(_this);
        return _this;
    }

    _createClass(EmailPreferenceToggleContainer, [{
        key: 'updatePreference',
        value: function updatePreference() {
            var _props = this.props,
                emailPreferenceEntry = _props.emailPreferenceEntry,
                currentUser = _props.currentUser,
                toggleEmailPreference = _props.toggleEmailPreference;

            var currentEmailPreference = currentUser.getIn(['settings', 'email']);
            var newEmailPreference = currentEmailPreference ^ emailPreferenceEntry.value;

            toggleEmailPreference(currentUser.get('_id'), newEmailPreference);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                currentUser = _props2.currentUser,
                emailPreferenceEntry = _props2.emailPreferenceEntry;

            var usersEmailPreferences = currentUser.getIn(['settings', 'email']);

            return _react2.default.createElement(_EmailPreferenceToggle2.default, {
                updatePreference: this.updatePreference,
                active: !!(usersEmailPreferences & emailPreferenceEntry.value),
                value: emailPreferenceEntry.value,
                label: emailPreferenceEntry.label });
        }
    }]);

    return EmailPreferenceToggleContainer;
}(_react2.default.Component)) || _class);


EmailPreferenceToggleContainer.propTypes = {
    toggleEmailPreference: _propTypes2.default.func,
    currentUser: _propTypes2.default.object.isRequired,
    emailPreferenceEntry: _propTypes2.default.object.isRequired
};

exports.default = EmailPreferenceToggleContainer;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/account/email/EmailPreferenceToggleContainer.js
// module id = 2175
// module chunks = 0